import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { useTranslation } from "pro-features/components/WithTranslation";

import { useDemographicsGenderDistributionData } from "../../hooks/useDemographicsGenderDistributionData";

import { GenderDistributionPieChart } from "./GenderDistributionPieChart";

export const IndustryAnalysisDemographicsGenderDistribution = () => {
    const t = useTranslation();
    const subtitleFilters = useSubtitleFilters("date");

    const { data: genderData, isLoading, isError } = useDemographicsGenderDistributionData();

    return (
        <WidgetContainer
            withBorder
            minWidth="100%"
            loaderHeight={240}
            loaderWidth="100%"
            isLoading={isLoading}
            noData={!isLoading ? isError || !genderData : null}
            subtitleFilters={subtitleFilters}
            title={t("category.demographics.gender.chart.title")}
            noDataTitle={t("category.demographics.chart.no.data.title")}
            noDataSubtitle={t("category.demographics.gender.chart.no.data")}
            automationId="industry-analysis-demographics-gender-distribution"
        >
            {genderData ? (
                <GenderDistributionPieChart
                    malePercent={genderData.malePercent}
                    femalePercent={genderData.femalePercent}
                />
            ) : null}
        </WidgetContainer>
    );
};
